import { render, staticRenderFns } from "./UploadAndViewFile.vue?vue&type=template&id=dd331818&scoped=true&"
import script from "./UploadAndViewFile.vue?vue&type=script&lang=js&"
export * from "./UploadAndViewFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd331818",
  null
  
)

export default component.exports